var React = require('react');

function Attention (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"stroke":"#FFAF00","strokeWidth":"3.25","cx":"32","cy":"32","r":"30.375","key":0}),React.createElement("path",{"d":"M32 49a2.1 2.1 0 1 1 0-4.2 2.1 2.1 0 0 1 0 4.2Zm1.983-30.986-.001.084-.546 21.558A1.447 1.447 0 0 1 32 41.055c-.77 0-1.404-.617-1.436-1.399l-.546-21.558c-.045-1.111.805-2.05 1.9-2.096L32 16c1.095 0 1.983.902 1.983 2.014Z","fill":"#FFAF00","key":1})]));
}

Attention.defaultProps = {"width":"64","height":"64","viewBox":"0 0 64 64"};

module.exports = Attention;

Attention.default = Attention;
